export default __webpack_public_path__ + "static/media/qr-code.001df64e.svg";